import { render, staticRenderFns } from "./ChooseBox.vue?vue&type=template&id=78632fa7&scoped=true"
import script from "./ChooseBox.vue?vue&type=script&lang=js"
export * from "./ChooseBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78632fa7",
  null
  
)

export default component.exports